import { Cloud, CloudOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/** Indicador de conexão (F8-T10). Informativo — não bloqueia nenhuma ação. */
export function ConnectionBadge(): React.ReactElement {
  const online = useOnlineStatus();

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${
        online ? 'bg-slate-800 text-slate-300' : 'bg-amber-500/15 text-amber-300'
      }`}
      // Anuncia a mudança para leitores de tela sem roubar o foco.
      role="status"
      aria-live="polite"
    >
      {online ? <Cloud size={14} aria-hidden /> : <CloudOff size={14} aria-hidden />}
      {online ? 'Online' : 'Offline'}
    </span>
  );
}
